$(document).ready(function(){
  var colorSlider = document.getElementById('color-slider');
  var claritySlider = document.getElementById('clarity-slider');
  var priceSlider = document.getElementById('price-slider');
  var caratSlider = document.getElementById('carat-slider');
  
  $(".diamond-filter-slider").each(function(){
    var _this = $(this);
    var id = $(this).attr("id");
    var action = $(this).attr("data-action");
    var type = $(this).attr("data-type");
    var target = document.getElementById(id);
    if(action == 'step')
    {
      var value = $(this).attr("data-value");
      value = value.split(",");
      var count = value.length;
      console.log(count);
    }
    else
    {
      var min = $(this).attr("data-min");
      var max = $(this).attr("data-max");
    }
    uislider(_this,target,action,value,count,min,max,type);
  });

  $(document).on("click",".diamond-item",function(){
      $(this).toggleClass("active");
      filter_search();
  });
  
  function uislider(_this,target,action,value,count,min,max,type)
  {
    if(action == 'step' )
    {
      noUiSlider.create(target, {
            range: {min:0, max:count},
            start: [0, count],
            connect: true,
            margin: 1,
            step: 1
      });
      var cut = '';
      var pos = 100/count;
      var updpos = 0;
      for (let i = 0; i < value.length; i++) {
         updpos += parseFloat(pos);
        cut += "<li class='cut"+i+"' style='left:"+updpos.toFixed(2)+"%'></li>";
      }
      _this.find(".noUi-base").append('<ol class="ui-slider-scale">'+cut+'</ol>');  
    }
    else
    {
      if(type == 'price')
      {
        noUiSlider.create(target, {
            range: {min:parseFloat(min), max:parseFloat(max)},
            start: [parseFloat(min), parseFloat(max)],
            connect: true,
            margin: 1,
            format: wNumb({
                decimals: 2,
                thousand: ',',
                prefix: '$'
            })
        });
      }
      else
      {
        noUiSlider.create(target, {
            range: {min:parseFloat(min), max:parseFloat(max)},
            start: [parseFloat(min), parseFloat(max)],
            connect: true,
            margin: 1
        });
      }


      target.noUiSlider.on('update', function (values, handle) {
          _this.siblings(".data-inputs").find("input").eq(handle).val(values[handle]);
      });
        
    }

    target.noUiSlider.on('change', function (values, handle) {
      filter_search();
    });
    
  }

  colorSlider.noUiSlider.set([1,6]);
  claritySlider.noUiSlider.set([0,4]);
  caratSlider.noUiSlider.set([0.25,2.50]);
  priceSlider.noUiSlider.set([56.00,115907.84]);

  $(".price-data .min").on("focus",function(){
    var val = $(this).val();
    val = val.replace("$","").replaceAll(",");
    $(this).val(parseInt(val));
  });

  $(".price-data .max").on("focus",function(){
    var val = $(this).val();
    val = val.replace("$","").replaceAll(",","");
    $(this).val(parseInt(val));
  });

  $(".min").on("change",function(){
    var id = $(this).parents(".data-inputs").siblings(".diamond-filter-slider").attr("id");
    var val = $(this).val();
    val = val.replace("$","").replaceAll(",");
    var val1 = $(this).siblings(".max").val();
    val1 = val1.replace("$","").replaceAll(",","");
    var target = document.getElementById(id);
    target.noUiSlider.set([val,val1]);
    filter_search();
  });
  
  $(".max").on("change",function(){
    var id = $(this).parents(".data-inputs").siblings(".diamond-filter-slider").attr("id");
    var val = $(this).val();
    val = val.replace("$","").replaceAll(",");
    var val1 =  $(this).siblings(".min").val();
    val1 = val1.replace("$","").replaceAll(",","");
    var target = document.getElementById(id);
    target.noUiSlider.set([val1,val]);
    filter_search();
  });

  $(".sort-opt").on("click",function(){
    var sort = $(this).attr("data-sort");
    var type = $(this).attr("data-type");
    $(this).toggleClass("active");
    var hasActive = $(this).hasClass("active");
    var OrderedDivs = $('.table-result-data > tr').sort(function (a, b) {
     var contentA = $(a).attr('data-'+sort);
     var contentB = $(b).attr('data-'+sort);
     if(hasActive)
     {
       if(type == 'numb')
       {
          return (contentA - contentB);
       }
       else
       {
         return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
       }
       
     }
     else
     {
       if(type == 'numb')
       {
         return (contentB - contentA);
       }
       else
       {
         return (contentA > contentB) ? -1 : (contentA < contentB) ? 0 : 1;
       } 
     }      
    });
    $(".table-result-data").html(OrderedDivs);
  });

  var str = location.search;
  if(str != '')
  {
    str = str.replace("?shape=","");
  
    $(".diamond-item[data-value='"+str+"']").addClass("active");
  }

  $(document).on("click",".result-row",function(){
    var id = $(this).attr("data-id");
   // window.location = '/pages/diamond-detail?id='+id;
    window.open('/pages/diamond-detail?id='+id, '_blank');
  });
  
  filter_search();
  


function filter_search(){
  var shapes = [];
  var color_to = colorSlider.noUiSlider.get()[0];
  var color_from = colorSlider.noUiSlider.get()[1];
  var clarity_to = claritySlider.noUiSlider.get()[0];
  var clarity_from = claritySlider.noUiSlider.get()[1];
  var size_to = caratSlider.noUiSlider.get()[0] ;
  var size_from = caratSlider.noUiSlider.get()[1];
  var price_total_to = priceSlider.noUiSlider.get()[0];
  var price_total_from = priceSlider.noUiSlider.get()[1];

  if($(".diamond-item.active").length != 0)
  {
    $(".diamond-item.active").each(function(){
      var vl = $(this).attr("data-value");
      shapes.push(vl);
    });
  }
  else
  {
    $(".diamond-item").each(function(){
      var vl = $(this).attr("data-value");
      shapes.push(vl);
    });
  }
  
  
  var colors = colorSlider.getAttribute("data-value").split(",");
  
  var clarity = claritySlider.getAttribute("data-value").split(",");
  
  color_to = colors[parseInt(color_to)];

  color_from = colors[parseInt(color_from) - 1];

  clarity_to = clarity[parseInt(clarity_to)];

  clarity_from = clarity[parseInt(clarity_from) - 1];

  price_total_from = price_total_from.replace("$","").replace(",","");
  
  price_total_to = price_total_to.replace("$","").replace(",","");

  var page_number = $(".table-result-data").attr("data-currentPage");

  $(".loader-wrapper").addClass("active");
  
  $(".loader-wrapper").parent().siblings().hide();
  
  filter_result(shapes,size_from,size_to,color_from,color_to,clarity_from,clarity_to,price_total_from,price_total_to,page_number);
  
}



function filter_result(shapes,size_from,size_to,color_from,color_to,clarity_from,clarity_to,price_total_from,price_total_to,page_number)
{
  var data = {
              "shapes": shapes, 
              "size_from": size_to, 
              "size_to": size_from, 
              "color_from": color_from, 
              "color_to": color_to, 
              "clarity_from": clarity_from, 
              "clarity_to": clarity_to,
              "price_total_from": price_total_from, 
              "price_total_to": price_total_to,
              "labs": ["GIA"],
              "page_number": page_number, 
              "page_size": 250,
              "sort_by": "clarity",
              "sort_direction": "Asc"
            };
  $.ajax({
    url: 'https://upbrighterservices.com/rapnet/diamond_search.php',
    type:  'POST',
    data: JSON.stringify(data),
    dataType:"json",
    success: function(data) {
      console.log(typeof(data));
      var result = data.response.body.diamonds;
      var error = data.response.header.error_code;
      console.log(error);
      if(result != undefined)
      {
        var resultData = ["<tr><td class='loader-wrapper' colspan='7'><div class='loader'></div></td></tr>"];
        var totalPages = data.response.body.search_results.total_diamonds_found/250;
        for (let i = 0; i < result.length; i++) {
          var shape = result[i].shape;
          var pric = result[i].total_sales_price_in_currency;
          if(result[i].size % 1 !== 0){
            var size = result[i].size.toString().split('.')[1].length;
            if(size === 1){
              var carat = result[i].size.toFixed(2);
            }else{
              var carat = result[i].size;
            }
          }
          
          // if(decimalCount(carat) != 1)
          // {
          //   carat = carat.toFixed(2);
          // }
          var cut = result[i].cut;
          var color = result[i].color;
          var clarity = result[i].clarity;
          var report = result[i].lab;
          var id = result[i].diamond_id;
          price = formatter.format(pric);

            resultData.push("<tr class='result-row' data-id="+id+" data-shape="+shape+" data-price="+pric+" data-carat="+carat+" data-cut="+cut+" data-color="+color+" data-clarity="+clarity+" data-report="+report+">"
                          +"<td>"+shape+"</td><td>"+price+"</td><td>"+carat+"</td><td>"+cut+"</td><td>"+color+"</td><td>"+clarity+"</td><td>"+report+"</td>"
                          +"</tr>");
          
          
        }
        $(".table-result-data").attr("data-pages",parseInt(totalPages));
        $(".table-result-data").html(resultData);
      }  

      if(error != 0)
      {
        $(".table-result-data").html("<tr><td class='loader-wrapper' colspan='7'><div class='loader'></div></td></tr><tr><td colspan='7'>No Diamond was found</td></tr>");
      }
      $(".sort-opt").removeClass("active");
      
      $(".result-row").hover(function () {
        $(this).addClass("onHover");
        $(this).siblings().removeClass("onHover");
     });
    }
  });
}

var formatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

const decimalCount = num => {
   const numStr = String(num);
   if (numStr.includes('.')) {
      return numStr.split('.')[1].length;
   };
   return 0;
}   


});

  $('.diamond-items').slick({
    infinite: false,
    arrow:true,
    slidesToShow: 6,
    slidesToScroll: 6
  });